import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules'; // 修改导入路径
import 'swiper/swiper-bundle.css';
import imgPrefix from '../imgConfig'; // 导入 imgConfig.js

const Carousel = () => {
  return (
    <Swiper
      modules={[Autoplay]}
      pagination={{ clickable: true }}
      loop
      autoplay={{ delay: 2000 }}
    >
      <SwiperSlide>
        <img src={`${imgPrefix}/upload/carosel1.jpg`} alt="Banner 1" style={{ width: "100%"}}/>
      </SwiperSlide>
      <SwiperSlide>
        <img src={`${imgPrefix}/upload/carosel2.jpg`} alt="Banner 2" style={{ width: "100%"}}/>
      </SwiperSlide>
    </Swiper>
  );
};

export default Carousel;
